import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';


const LifecycleInput: InputWithSource = ({ input }) => (
    <GenericSelect label={input.name} input={input} message={ValidationMessages.requiredInput(input.name)} />
);

LifecycleInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(LifecycleInput);
